import React, { useState } from "react";
import { Download } from "lucide-react";
import { supabase, supabaseConfigured } from "../lib/supabase";
import {
  downloadSouvenirPdf,
  isSouvenirPdfDownloadConfigured,
} from "../lib/souvenirPdf";

const VARIANT_CLASS = {
  default:
    "inline-flex items-center gap-2 rounded-lg border border-line bg-white text-ink-900 hover:bg-ivory-100 hover:border-burgundy-600/30 font-medium px-5 py-3 shadow-card transition-colors disabled:opacity-60 disabled:pointer-events-none",
  primary:
    "inline-flex items-center gap-2 rounded-lg bg-burgundy-600 hover:bg-burgundy-700 text-white font-medium px-5 py-3 shadow-card transition-colors disabled:opacity-60 disabled:pointer-events-none",
};

export default function SouvenirPdfDownloadButton({
  variant = "default",
  testId = "hero-souvenir-pdf-download",
}) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  if (!isSouvenirPdfDownloadConfigured(supabaseConfigured)) {
    return null;
  }

  async function handleClick() {
    setError(null);
    setBusy(true);
    try {
      await downloadSouvenirPdf(supabase);
    } catch (e) {
      setError(e?.message || "Download failed.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="inline-flex flex-col items-start gap-1">
      <button
        type="button"
        onClick={handleClick}
        disabled={busy}
        className={VARIANT_CLASS[variant] ?? VARIANT_CLASS.default}
        data-testid={testId}
        aria-busy={busy}
      >
        <Download size={16} aria-hidden />
        {busy ? "Preparing download…" : "Download souvenir PDF"}
      </button>
      {error ? (
        <p className="text-sm text-burgundy-600 max-w-md" role="alert">
          {error}
        </p>
      ) : null}
    </div>
  );
}
